import "styles/layout/mobile-header.less";
import { FC, useState } from "react";

import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { Col, Drawer, Modal, Row } from "antd";
import aiChatLogo from "assets/images/ai-chat-logo.svg";
import close from "assets/images/new-questionnaire/close.svg";
import taxzapLogo from "assets/images/taxzap-logo-R.svg";
import DropDownMobile from "components/pages/Profile/tabs/Homepage/DropDownMobile";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Link } from "react-router-dom";
import { IUser } from "types/auth";

import SideNavigation from "./SideNavigation";
import { getAccessToken } from "../../../../../utils/auth";
import { Step } from "../../constants/questions";
import BankAccount from "../BankAccount/BankAccount";
import ProgressDivider from "../ProgressDivider";

type HeaderProps = {
    user: IUser;
    handleContinue: () => void;
    currentStepData: Step;
    totalProgress: number;
    refetchConnectedBankAccounts: () => any;
};

const MobileHeader: FC<HeaderProps> = ({ user, handleContinue, totalProgress, refetchConnectedBankAccounts }) => {
    const [openBankAccounts, setOpenBankAccounts] = useState(false);
    const [isNavigationMenuOpen, setIsNavigationMenuOpen] = useState(false);
    const { isZappyEnabled } = useFlags();

    const toggleMenu = () => {
        setIsNavigationMenuOpen(!isNavigationMenuOpen);
    };

    const handleChatClick = async () => {
        const token = await getAccessToken();
        // @ts-ignore
        window.$chatwoot?.setCustomAttributes({
            updatedAt: new Date().toISOString(),
            pendingQuestion: null,
            transactionId: null,
            totalAmount: null,
            description: null,
            token,
        });
        // @ts-ignore
        if (typeof window !== "undefined" && window.$chatwoot?.toggle) {
            // @ts-ignore
            window.$chatwoot.toggle("open");
        }
    };

    return (
        <>
            <Row className="mobile-header w100 center">
                <Col span={8} className="taLeft">
                    <MenuOutlined className="mr4" onClick={toggleMenu} />
                    <span className="pointer" onClick={toggleMenu}>Menu</span>
                </Col>

                <Drawer
                    title={<img src={taxzapLogo} height={24} alt="taxzap logo" />}
                    open={isNavigationMenuOpen}
                    onClose={toggleMenu}
                    footer={null}
                    width={"100%"}
                    placement="left"
                    closeIcon={<CloseOutlined />}
                    className="mobile-header__drawer"
                >
                    <SideNavigation close={toggleMenu} />
                </Drawer>

                <Col span={8} className="taCenter">
                    <Link to={"profile"} className="mobile-header__profile-link">
                        <img
                            className="dblock logo-questionnaire mAuto"
                            src={taxzapLogo}
                            alt="TaxZap Logo"
                            style={{ cursor: "default" }}
                        />
                    </Link>
                </Col>

                <Col span={8} className="taRight" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px" }}>
                    {/* Ask Zappy Button for Mobile */}
                    {isZappyEnabled && (
                        <div
                            style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                cursor: "pointer",
                            }}
                            onClick={handleChatClick}
                        >
                            {/* Beta Tag */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-14px",
                                    right: "-10px",
                                    backgroundColor: "#6541da",
                                    color: "#ffffff",
                                    fontSize: "10px",
                                    fontWeight: "600",
                                    padding: "2px 6px",
                                    borderRadius: "999px",
                                    lineHeight: 1,
                                    pointerEvents: "none",
                                }}
                            >
                            Beta
                            </div>
                            <img
                                src={aiChatLogo}
                                alt="Ask Zappy"
                                style={{
                                    height: "25px",
                                    objectFit: "contain",
                                    marginRight: "6px",
                                }}
                            />
                        </div>)}

                    {/* Existing User Dropdown */}
                    <DropDownMobile
                        firstName={user.info.firstName}
                        lastName={user.info.lastName}
                        email={user.info.email}
                    />
                </Col>
            </Row>
            <ProgressDivider progress={totalProgress}/>
            <Modal
                open={openBankAccounts}
                width={355}
                destroyOnClose
                closable={false}
                onCancel={() => setOpenBankAccounts(false)}
                footer={null}
                className="shared__prompt-modal"
                styles={{
                    content: {
                        borderRadius: "20px",
                        padding: "20px!important",
                    },
                }}
                centered
            >
                <div className="new-questionnaire__bank-accounts-modal">
                    <div className="new-questionnaire__bank-accounts-close" onClick={() => setOpenBankAccounts(false)}>
                        <img src={close} alt="close" className="dblock p16"/>
                    </div>
                    <BankAccount
                        user={user}
                        handleContinue={handleContinue}
                        isHeaderComponent={true}
                        refetchConnectedBankAccounts={refetchConnectedBankAccounts}
                    ></BankAccount>
                </div>
            </Modal>
        </>
    );
};

export default MobileHeader;
